import { render, staticRenderFns } from "./LiveStats.vue?vue&type=template&id=3f403397&"
import script from "./LiveStats.vue?vue&type=script&lang=js&"
export * from "./LiveStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports